import { FormikProps } from 'formik';
import dayjs from 'dayjs';
import React from 'react';
import { DatePicker, Select } from 'antd';
import styled from 'styled-components';
import * as yup from 'yup';

import { exportsDropdown } from './options';
import { ExportFormValues } from '../interface/exports.interface';

const { RangePicker } = DatePicker;

const StyledSelect = styled(Select)`
    width: 100%;
`;

export const fields = [
    {
        id: 'type',
        title: 'Таблица',
        type: 'select',
    },

    {
        id: 'dates',
        title: 'Интервал выгрузки',
        type: 'date',
    },
];

const fieldRenderers = {
    select: (formik: FormikProps<ExportFormValues>) => (
        <StyledSelect
            showSearch
            placeholder={'Выберите таблицу'}
            value={formik.values.type}
            onChange={value => formik.setFieldValue('type', value)}
            options={exportsDropdown}
            filterOption={(input, option) =>
                typeof option?.label === 'string' &&
                option.label.toLowerCase().includes(input.toLowerCase())
            }
        />
    ),
    date: (formik: FormikProps<ExportFormValues>) => (
        <RangePicker
            value={
                formik.values.start_at && formik.values.end_at
                    ? [
                          dayjs(formik.values.start_at, 'DD-MM-YYYY HH:mm:ss'),
                          dayjs(formik.values.end_at, 'DD-MM-YYYY HH:mm:ss'),
                      ]
                    : undefined
            }
            disabledDate={current => current && current > dayjs().endOf('day')}
            onChange={value => {
                if (Array.isArray(value)) {
                    formik.setFieldValue(
                        'start_at',
                        value[0]?.format('DD-MM-YYYY HH:mm:ss')
                    );
                    formik.setFieldValue(
                        'end_at',
                        value[1]?.format('DD-MM-YYYY HH:mm:ss')
                    );
                }
            }}
        />
    ),
};

export const renderField = (
    fieldType: string,
    formik: FormikProps<ExportFormValues>
) => {
    const renderer = fieldRenderers[fieldType];
    return renderer ? renderer(formik) : null;
};

export const validationSchema = yup.object().shape({
    type: yup
        .string()
        .oneOf(
            ['orders', 'visitors'],
            'Тип экспорта должен быть Заказы или Посетители'
        )
        .required('Тип обязателен'),
    start_at: yup
        .string()
        .required('Дата начала обязательна')
        .matches(
            /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/,
            'Дата должна быть в формате DD-MM-YYYY HH:mm:ss'
        ),
    end_at: yup
        .string()
        .required('Дата окончания обязательна')
        .matches(
            /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/,
            'Дата должна быть в формате DD-MM-YYYY HH:mm:ss'
        ),
});
